import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=4af804b5&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style1 from "./reset-password.vue?vue&type=style&index=1&id=4af804b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af804b5",
  null
  
)

export default component.exports